import styled from 'styled-components';
import { Col } from 'antd';

import { Paragraph, Text } from '@/components/Typography';

export const HeaderCol = styled(Col)`
	margin-bottom: 2.5rem;
`;

export const SubtitleCol = styled(Col)`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: 0.5rem;
`;

export const StepTitle = styled(Text)`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
`;

export const StepDate = styled(Text)`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	white-space: nowrap;
`;

export const StepSubtitle = styled(Paragraph)`
	&& {
		margin-bottom: 0;
	}

	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_md};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
`;
